import type { CommonCode } from '../model/CommonCode';
import type { ApiHelper, ApiResponseWithData, BaseRequest } from '..';
import { ApiHelperWithData, splitParams } from '..';

export class CommonCodeApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  //
  /**
   * CodeType 매개변수를 받아 Code값을 가져온다
   */
  fetchCodeOptionsByCodeType = (
    params: {
      codeType: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ codeList: CommonCode[] }>> => {
    const url = '/api/cmmn/code/info';
    return this.withData.post(url, ...splitParams(params));
  };
}
